const CLOCK_STATUS_EVENT = 'CLOCK_STATUS_CHANGED';
const CLOCK_STATUS_CHANNEL = 'kino-clock-status';
const CLOCK_STATUS_STORAGE_KEY = 'kino.clock.status';

let channel = null;

function getChannel() {
    if (channel || typeof BroadcastChannel === 'undefined') {
        return channel;
    }

    channel = new BroadcastChannel(CLOCK_STATUS_CHANNEL);
    return channel;
}

function createPayload(clock) {
    return {
        clock: clock && !clock.error && clock.id ? clock : null,
        timestamp: Date.now(),
    };
}

export function notifyClockStatusChanged(clock) {
    const payload = createPayload(clock);

    window.dispatchEvent(new CustomEvent(CLOCK_STATUS_EVENT, { detail: payload }));

    try {
        getChannel()?.postMessage(payload);
    } catch (error) {
        console.warn('[Kino Clock] BroadcastChannel sync failed', error);
    }

    try {
        localStorage.setItem(CLOCK_STATUS_STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {
        console.warn('[Kino Clock] localStorage sync failed', error);
    }
}

export function subscribeClockStatusChanged(handler) {
    const handleWindowEvent = (event) => {
        handler(event.detail?.clock ?? null);
    };

    const handleChannelMessage = (event) => {
        handler(event.data?.clock ?? null);
    };

    const handleStorageEvent = (event) => {
        if (event.key !== CLOCK_STATUS_STORAGE_KEY || !event.newValue) {
            return;
        }

        try {
            const payload = JSON.parse(event.newValue);
            handler(payload?.clock ?? null);
        } catch (error) {
            console.warn('[Kino Clock] storage sync parse failed', error);
        }
    };

    window.addEventListener(CLOCK_STATUS_EVENT, handleWindowEvent);
    window.addEventListener('storage', handleStorageEvent);

    const broadcastChannel = getChannel();
    broadcastChannel?.addEventListener('message', handleChannelMessage);

    return () => {
        window.removeEventListener(CLOCK_STATUS_EVENT, handleWindowEvent);
        window.removeEventListener('storage', handleStorageEvent);
        broadcastChannel?.removeEventListener('message', handleChannelMessage);
    };
}
